import common from 'ui-react-common';
import URC from 'ui-react-common';
import * as types from './action-types';

const globalActions = common.globals.methods.actions;

const FAILED_MESSAGE = 'Failed to succeed';

const api = URC.services.coreAPIInstance;
const isLoggedIn = () => (dispatch) => {
    dispatch(pendingAuth());

    return api.authentication
        .isLoggedIn()
        .then((user) => dispatch(successfulAuth(user)))
        .catch((error) => {
            dispatch(failedAuth(error));
            dispatch(globalActions.failedAction(FAILED_MESSAGE));
        });
};

const logout = () => (dispatch) => {
    dispatch(pendingAuth());

    return api.authentication
        .logout()
        .then((user) => dispatch(successfulAuth(user)))
        .catch((error) => {
            dispatch(failedAuth(error));
            dispatch(globalActions.failedAction(FAILED_MESSAGE));
        });
};

const pendingAuth = () => ({
    type: types.PENDING_CHECKAUTH,
});

const failedAuth = (error) => ({
    type: types.FAILED_CHECKAUTH,
    error,
});

const successfulAuth = (user) => ({
    type: types.SUCCESSFULLY_CHECKAUTH,
    user,
});

export default {
    FAILED_MESSAGE,
    isLoggedIn,
    logout,
    pendingAuth
};
